export const authErrorMessages: {[key: string]: string} = {
  'user does not exists': `We don’t recognize this email. Please confirm your email address.`,
  'no such applicant': `We don’t recognize this email. Please confirm your email address.`,
  'no firm': `We don’t recognize this email. Please confirm your email address.`,
  'no application': `We don’t recognize this email. Please confirm your email address.`,
  'an active token already exist': `You’ve previously requested a new authentication link, please check your inbox again. Be sure and check your spam/junk folder.`,
  'default': 'An error has ocurred when requesting a new authentication link. Please try again.'
}
// validEmailPattern
// allows + before the @
// allows longer TLD suffix (see https://en.wikipedia.org/wiki/List_of_Internet_top-level_domains)
export const validEmailPattern = /^[a-zA-Z0-9\+._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,12}$/;
